import './sac-list-insert.scss';

import { cn } from '@sola/ark-core/utils/helpers.ts';
import { SacFilterProps } from '@sola/schema/lib/schema.ts';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.ts';

import { FeatureBase } from '../../../molecules/feature-base/feature-base.tsx';
import { FeatureButtons } from '../../../molecules/feature-buttons/feature-buttons.tsx';
import { SacList } from '../../../molecules/sac-list/sac-list.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';

export const SacListInsert: React.FC<SacFilterProps> = ({
  seoLevel = 2,
  title,
  subtitle,
  body,
  primaryCTA,
  secondaryCTA,
  tertiaryCTA,
  ...sacList
}) => {
  const hasHeaderContent = !!title || !!body;
  const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);

  const hasButtons = !!primaryCTA || !!secondaryCTA || !!tertiaryCTA;

  return (
    <section className="SacListInsert component">
      <div className="container flex flex-col gap-comfy-xl">
        {hasHeaderContent && (
          <div className={cn('w-full mx-auto')}>
            <FeatureBase
              {...getBaseSizeProps(headerDisplayLevel)}
              seoLevel={seoLevel}
              {...{ title, body }}
              variant="centered"
              variantResponsive
              inline
            />
          </div>
        )}

        <SacList {...sacList} columnsMd="3" />

        <div className="flex flex-col md:flex-row items-center md:justify-between gap-comfy-lg">
          {subtitle && (
            <FeatureBase
              body={<p>{subtitle}</p>}
              bodySize="sm"
              className="max-w-md"
              inline
            />
          )}
          {hasButtons && (
            <FeatureButtons
              {...{ primaryCTA, secondaryCTA, tertiaryCTA }}
              variant="noWrap"
            />
          )}
        </div>
      </div>
    </section>
  );
};
